import React from "react";
import "../App.css";
import { useState } from "react";
import { useLocation} from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";


const MultiplicationView = (array) => {
    const { row, column } = array;

    console.log("row: ",row)
    console.log("column: ",column)

    function transposeMatrix(matrix) {
        const numRows = matrix.length;
        const numCols = matrix[0].length;
    
        const transposedMatrix = [];
    
        for (let col = 0; col < numCols; col++) {
          transposedMatrix[col] = [];
          for (let row = 0; row < numRows; row++) {
            transposedMatrix[col][row] = matrix[row][col];
          }
        }
    
        return transposedMatrix;
      }

      function binaryToHex(binaryString) {
        const decimalValue = parseInt(binaryString, 2);
        const hexString = decimalValue.toString(16).toUpperCase();
        return hexString;
      }
    
    function leftShiftWithPadding(inputBinary, shiftAmount = 1) {
        // Check if the input binary string is exactly 8 bits long
        if (inputBinary.length !== 8) {
          console.error("Input binary string must be 8 bits long.");
          return null;
        }
    
        // Perform the left shift
        const shiftedBinary =
          inputBinary.slice(shiftAmount) + "0".repeat(shiftAmount);
    
        return shiftedBinary;
      }
    
      function bitwiseXOR(input1, input2) {
        // Check if the inputs are exactly 8 bits long
    
        // Perform the bitwise XOR operation
        let result = "";
        for (let i = 0; i < 8; i++) {
          result += input1[i] ^ input2[i];
        }
    
        return result;
      }
    
      function multiplyInGF(a, b) {
        let product = "";
    
        //multiplying with 01
        if (a == 1) {
            let bin = hexToBinary(b);
            binArray1.push(bin)
          product = hexToBinary(b);
        }
    
        //multiplying with 02
        else if (a == 2) {
          let bin = hexToBinary(b);
          //console.log("bin: ",bin)
          let shiftedBin = leftShiftWithPadding(bin);
          //console.log("shiftedBin: ",shiftedBin)
          binArray2.push(bin)
          shiftedBinArray2.push(shiftedBin)
          product = shiftedBin;
          if (bin[0] == "1") {
            product = bitwiseXOR(shiftedBin, "00011011");
          }
          let productHex2 = binaryToHex(product);
          result2.push(productHex2)
          //console.log("product: ",product)
        }
    
        //multiplying with 03
        else {
          let bin = hexToBinary(b);
          binArray3.push(bin)
          let shiftedBin = leftShiftWithPadding(bin);
          shiftedBinArray3.push(shiftedBin)
          let mulWith2 = shiftedBin;
          if (bin[0] == "1") {
            mulWith2 = bitwiseXOR(shiftedBin, "00011011");
          }
          mul2array.push(mulWith2)
          product = bitwiseXOR(bin, mulWith2);
          bitwiseXORArray.push(product)
          let productHex3 = binaryToHex(product);
          result3.push(productHex3)
        }
        let productHex = binaryToHex(product);
        return productHex;
      }
    
      function hexToBinary(hexString) {
        // Parse the hex string to an integer
        const decimalValue = parseInt(hexString, 16);
    
        // Convert the integer to an 8-bit binary string
        const binaryString = decimalValue.toString(2).padStart(8, "0");
    
        return binaryString;
      }

      const xorHexValues = (hexArray) => {
        if (hexArray.length < 2) {
          return null; // XOR requires at least two values
        }
      
        // Convert hexadecimal values to decimal
        const decimalArray = hexArray.map(hex => parseInt(hex, 16));
      
        // Perform XOR operation
        const result = decimalArray.reduce((accumulator, currentValue) => accumulator ^ currentValue);
      
        // Convert the result back to hexadecimal
        const hexResult = result.toString(16).toUpperCase();
      
        return hexResult;
      };

      let binArray1 = []
      let binArray2 = []
      let shiftedBinArray2 = []
      let result2 = []
      let binArray3 = []
      let shiftedBinArray3 = []
      let mul2array = []
      let bitwiseXORArray = []
      let result3 = []

      const calculate = (row , column) => {
        let mixColAns = []
        
        for(let i=0 ; i<4 ; i++){
            mixColAns.push(multiplyInGF(row[i],column[i]))
        }
        let xorAns = xorHexValues(mixColAns)

        return [mixColAns , xorAns]
      }

      let mixColAns,xorAns = calculate(row , column)
      console.log("xorAns:",xorAns)
      
      
    return (
        <>  
            <div className="bg-emerald-100 rounded-xl w-auto p-3">
              <p>Let's usderstand how [{row[0]} {row[1]} {row[2]} {row[3]}] X [{column[0]} {column[1]} {column[2]} {column[3]}] is happening</p>
              <p>Step 1:<br></br><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>[{row[0]} x {column[0]}] XOR [{row[1]} x {column[1]}] XOR[{row[2]} x {column[2]}] XOR[{row[3]} x {column[3]}]</p>
              <p>Step 2:Lets calculate [{row[0]} x {column[0]}]<br></br>
                
                {
                row[0] === 1 && (
                    <>
                    
                    <p><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      {[row[0], 'x', column[0]].join(' ')} = {column[0]}
                    </p>
                    </>
                  )
                }
                
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                {
                    
                row[0] === 2 && (
                    <>
                    
                    {
                    ['Lets convert ', column[0], ' into its binary form '].join(' ')
                    } = {binArray2.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'if msb of the binary form is not 1'}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'perform a simple left shift'}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'if msb of the binary form is 1'}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'then perform left shift and XOR with 00011011'} = {shiftedBinArray2.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'convert this back to HEX'} = {result2.shift()}
                    
                    </>
                )
                }

                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                {
                    
                row[0] === 3 && (
                    <>
                    {
                    ['[',row[0],'x',column[0],']','=', '1 x' , column[0] , 'XOR' , '2 x' , column[0]].join(' ')}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {['1 x' , column[0]].join(" ")} = {binArray3.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {['2 x' , column[0]].join(" ")} = {mul2array.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {['perform bitwise XOR for these 2'].join(" ")} = {bitwiseXORArray.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'convert this back to HEX'} = {result3.shift()}
                    
                    </>
                )
                }
              </p>


              <p>Step 3:Lets calculate [{row[1]} x {column[1]}]<br></br>
                
                {
                row[1] === 1 && (
                    <>
                    
                    <p><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      {[row[1], 'x', column[1]].join(' ')} = {column[1]}
                    </p>
                    </>
                  )
                }
                
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                {
                    
                row[1] === 2 && (
                    <>
                    
                    {
                    ['Lets convert ', column[1], ' into its binary form '].join(' ')
                    } = {binArray2.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'if msb of the binary form is not 1'}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'perform a simple left shift'}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'if msb of the binary form is 1'}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'then perform left shift and XOR with 00011011'} = {shiftedBinArray2.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'convert this back to HEX'} = {result2.shift()}
                    
                    </>
                )
                }

                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                {
                    
                row[1] === 3 && (
                    <>
                    {
                    ['[',row[1],'x',column[1],']','=', '1 x' , column[1] , 'XOR' , '2 x' , column[1]].join(' ')}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {['1 x' , column[1]].join(" ")} = {binArray3.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {['2 x' , column[1]].join(" ")} = {mul2array.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {['perform bitwise XOR for these 2'].join(" ")} = {bitwiseXORArray.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'convert this back to HEX'} = {result3.shift()}
                    
                    </>
                )
                }
              </p>


              <p>Step 4:Lets calculate [{row[2]} x {column[2]}]<br></br>
                
                {
                row[2] === 1 && (
                    <>
                    
                    <p><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      {[row[2], 'x', column[2]].join(' ')} = {column[2]}
                    </p>
                    </>
                  )
                }
                
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                {
                    
                row[2] === 2 && (
                    <>
                    
                    {
                    ['Lets convert ', column[2], ' into its binary form '].join(' ')
                    } = {binArray2.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'if msb of the binary form is not 1'}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'perform a simple left shift'}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'if msb of the binary form is 1'}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'then perform left shift and XOR with 00011011'} = {shiftedBinArray2.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'convert this back to HEX'} = {result2.shift()}
                    
                    </>
                )
                }

                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                {
                    
                row[2] === 3 && (
                    <>
                    {
                    ['[',row[2],'x',column[2],']','=', '1 x' , column[2] , 'XOR' , '2 x' , column[2]].join(' ')}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {['1 x' , column[2]].join(" ")} = {binArray3.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {['2 x' , column[2]].join(" ")} = {mul2array.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {['perform bitwise XOR for these 2'].join(" ")} = {bitwiseXORArray.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'convert this back to HEX'} = {result3.shift()}
                    
                    </>
                )
                }
              </p>


              <p>Step 5:Lets calculate [{row[3]} x {column[3]}]<br></br>
                
                {
                row[3] === 1 && (
                    <>
                    
                    <p><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      {[row[3], 'x', column[3]].join(' ')} = {column[3]}
                    </p>
                    </>
                  )
                }
                
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                {
                    
                row[3] === 2 && (
                    <>
                    
                    {
                    ['Lets convert ', column[3], ' into its binary form '].join(' ')
                    } = {binArray2.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'if msb of the binary form is not 1'}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'perform a simple left shift'}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'if msb of the binary form is 1'}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'then perform left shift and XOR with 00011011'} = {shiftedBinArray2.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'convert this back to HEX'} = {result2.shift()}
                    
                    </>
                )
                }

                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                {
                    
                row[3] === 3 && (
                    <>
                    {
                    ['[',row[3],'x',column[3],']','=', '1 x' , column[3] , 'XOR' , '2 x' , column[3]].join(' ')}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {['1 x' , column[3]].join(" ")} = {binArray3.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {['2 x' , column[3]].join(" ")} = {mul2array.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {['perform bitwise XOR for these 2'].join(" ")} = {bitwiseXORArray.shift()}
                    <br /><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {'convert this back to HEX'} = {result3.shift()}
                    
                    </>
                )
                }
              </p>    
              <p>Step 6: lets calculate the final answer
                <br></br><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                [{row[0]} x {column[0]}] XOR [{row[1]} x {column[1]}] XOR[{row[2]} x {column[2]}] XOR[{row[3]} x {column[3]}] = {xorAns[1]}
              </p>
            </div>
            
        </>
    );
}

export default MultiplicationView